export default {
  // 域名下发接口
  getDomainPool: async () => {
    // return await Service.get('/api/v1/h5/growth-app/domain/assign', params)
    return {}
  },
}
